<template>
  <div class="member_center">    
    <loading v-if="loading"/>
    <!-- 會員中心 -->
    <section class="">
      <div class="container member-center-box">
        <div class="row">
          <div class="col-lg-12 text-center">
            <h2 class="section-heading text-uppercase">Member Center</h2>
            <h3 class="section-subheading text-muted">會員中心</h3>
          </div>
        </div>
        <div class="row">
          <div class="col-md-8 member-center-login">
            <a class="btn btn-line btn-xl text-uppercase js-scroll-trigger" :href="url">LINE 登入</a>
          </div>
          
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'MemberCenterLogin',
  props: {
    msg: String
  },
  data() {
    return {
      url : "https://access.line.me/oauth2/v2.1/authorize?response_type=code&client_id=" + process.env.VUE_APP_BRAND_LINE_ID + "&redirect_uri=https://" + process.env.VUE_APP_API_URL + "/users/login?brand=" + process.env.VUE_APP_BRAND + "&scope=openid%20profile&state=",
      token : "",
      loading: true
    }
  },
  mounted() {
    var self = this;
    self.getLoginToken()
  },
  methods: {
    getLoginToken: function() {
      var self = this
      self.$http.get('https://' + process.env.VUE_APP_API_URL + '/users/line_login_token')
        .then((response) => {
          self.loading = false
          self.token = response.body.token
          self.url = self.url + self.token
        })
        .catch((response) => {
          self.loading = false
          self.$router.push({ name: 'member_center' })
        })
        .finally(() => {
        });
    }
  }
}
</script>